module.exports = __webpack_public_path__ + "static/media/AI.a9f69025.jpeg";